/* eslint-disable require-jsdoc */
import SurveyStore from './SurveyStore';

const survey = new SurveyStore();

export const stores = {survey};
